import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
	Button
} from 'reactstrap';
import Select from 'react-select';
import Datetime from 'react-datetime';
import { Get, Post, JENIS_DUSUN } from '../../function/Koneksi';
import { generateAlamat } from '../../function/Format';

const ModalBlangkoNikah = ({ data, optionData, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData, kiosk }) => {
	const dateFormat = require('dateformat');

	const frmSurat = {
		uuid: '',
		id_jenis: '',
		nik_pelapor: '',
		nik: '',
		kk:'',
		nama_pemohon: '',
		tempat_lahir: '',
		tanggal_lahir: '',
		jenis_kelamin: '',
		pekerjaan: '',
		agama: '',
		alamat: '',
		alamat_kk: '',
		pendidikan_terakhir: '',
		kewarganegaraan: '',
		tujuan_pembuatan: '',
		status_perkawinan: null,
		status_perkawinan_lk: null,
		status_perkawinan_pr: null,
		status_perkawinan_lk_lainnya: "",
		// Data Ayah
		nik_ayah:"",
		nama_ayah: '',
		bin_binti_ayah: '',
		tempat_lahir_ayah: '',
		tanggal_lahir_ayah: '',
		agama_ayah: '',
		pekerjaan_ayah: '',
		alamat_ayah: '',
		// Data Ibu
		nik_ibu: '',
		nama_ibu: '',
		bin_binti_ibu: '',
		tempat_lahir_ibu: '',
		tanggal_lahir_ibu: '',
		agama_ibu: '',
		pekerjaan_ibu: '',
		alamat_ibu: '',
		// Data Pasangan
		nik_pasangan: '',
		nama_pasangan: '',
		bin_binti_pasangan: '',
		tempat_lahir_pasangan: '',
		tanggal_lahir_pasangan: '',
		agama_pasangan: '',
		pekerjaan_pasangan: '',
		alamat_pasangan: '',
		// Data Pasangan Sebelumnya
		nik_ex_pasangan: '',
		nama_ex_pasangan: '',
		bin_binti_ex_pasangan: '',
		tempat_lahir_ex_pasangan: '',
		tanggal_lahir_ex_pasangan: '',
		agama_ex_pasangan: '',
		pekerjaan_ex_pasangan: '',
		alamat_ex_pasangan: '',
		tempat_ex_meninggal: '',
		tanggal_ex_meninggal: '',
		status_hubungan: '',
		// Data Pernikahan
		tanggal_pernikahan: null,
		jam_pernikahan: null,
		waktu_pernikahan: '',
		lokasi_pernikahan: '',
		lampiran: [],
		detail: [],
	}

	const initFormData = {
		frmNik: optionData.frmNik,
		tmplistPenduduk: optionData.tmplistPenduduk,
		nikStat: null,
		detail: [],
		frmStatusPerkawinan: optionData.frmStatusPerkawinan,
		frmStatusPerkawinanLk: optionData.frmStatusPerkawinanLk,
		frmStatusPerkawinanPr: optionData.frmStatusPerkawinanPr,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
			dataPenduduk: "none",
			frmPreviewDraft: false,
			jenis_form: '',
			nikMantan: optionData.status.nikMantan,
			jklk: optionData.status.jklk,
			jkpr: optionData.status.jkpr,
			jenis_kelamin_pelapor: optionData.status.jenis_kelamin_pelapor,
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
		
		// Preview surat
		get_data_surat:[],
		get_jenis_surat: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [props, setProps] = useState(propsData)
	const [kioskMode, setKioskMode] = useState(kiosk)
	const [dt, setDt] = useState(data ? data : frmSurat)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		// console.log('data useeffect')
		// console.log(data)
		// console.log(optionData)

		setDt(data ? data : frmSurat)
		setFormData(data ? {
			...initFormData,
			nikStat: optionData.nikStat,
			status: optionData.status,
			frmStatusPerkawinan: optionData.frmStatusPerkawinan,
			frmStatusPerkawinanLk: optionData.frmStatusPerkawinanLk,
			frmStatusPerkawinanPr: optionData.frmStatusPerkawinanPr,
		} : initFormData)

	}, [isOpen])

	const handleSelectChange = (e, fld) => {
		if (e) {
		  // console.log("ini handle select", dt)
		  setDt({
			...dt,
			[fld]: e
		  });
		}
		else{
		  setDt({
			...dt,
			[fld]: null,
		  })
		}
	};

	const handleInputChange = (e, fld) => {
		setDt({
			...dt,
			[fld]: e.target.value
		});
	};

	const handleInputChangeNIK = (e, fld) => {
		if (e && kioskMode == false) {
			let nikStat = { value: e, label: e };

			Post("penduduk", null, { nik: e }, datanik => {
				let frmNik = [];
				let tmplistPenduduk = {}
				datanik.data.results.data.forEach(dt => {
					frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
					tmplistPenduduk = {
						...tmplistPenduduk,
						[dt.id]: dt
					}
				});

				switch (fld) {
					case "nik":
						setFormData({
							...formData,
							frmNik,
							tmplistPenduduk,
							nikStat
						})
						break;

					default:
						break;
				}

			});

		}
	};

	const changeSelectValue = (e, sel, jns) => {
		// console.log(e.label);
		let nikMantan = "none";
		let dataEx = {};

		if (e) {
			switch (jns) {
				case "status_perkawinan":
					if (e.label === "Cerai mati") {
						nikMantan = "block";
						dataEx = {
							nik_ex_pasangan: "",
							nama_ex_pasangan: "",
							bin_binti_ex_pasangan: "",
							tempat_lahir_ex_pasangan: "",
							tanggal_lahir_ex_pasangan: null,
							kewarganegaraan_ex_pasangan: "",
							agama_ex_pasangan: "",
							pekerjaan_ex_pasangan: "",
							alamat_ex_pasangan: "",
							tempat_ex_meninggal: "",
							tanggal_ex_meninggal: null,
							status_hubungan: "",
						};
					}
					setDt({
						...dt,
						[sel]: e,
						dataEx
					});
					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk5: "none",
							nikMantan
						},
					});
				break;
				default:
					// setDt({
					// 	...dt,
					// 	[sel]: e
					// });
				break;
			}
		}
		else{
			switch (jns) {
				case "status_perkawinan":
					nikMantan = "none";
					dataEx = {
						nik_ex_pasangan: "",
						nama_ex_pasangan: "",
						bin_binti_ex_pasangan: "",
						tempat_lahir_ex_pasangan: "",
						tanggal_lahir_ex_pasangan: null,
						kewarganegaraan_ex_pasangan: "",
						agama_ex_pasangan: "",
						pekerjaan_ex_pasangan: "",
						alamat_ex_pasangan: "",
						tempat_ex_meninggal: "",
						tanggal_ex_meninggal: null,
						status_hubungan: "",
					};

					setDt({
						...dt,
						[sel]: null,
						dataEx
					});

					setFormData({
						...formData,
						status: {
							...formData.status,
							dataPenduduk5: "none",
							nikMantan
						},
					});
				break;
				default:
					// setDt({
					// 	...dt,
					// 	[sel]: e
					// });
				break;
			}
		}
	};

	const openLoading = () => {
		if (kioskMode) {
			props.setLoadingPreview(true)
		}
		else{
			setAlert({
				loadingPreview: true
			})
		}
	}

	const closeLoading = () => {
		if (kioskMode) {
			props.setLoadingPreview(false)
		}
		else{
			setAlert({
				loadingPreview: false
			})
		}
	}

	const getPenduduk = (e, sel, jns) => {
		if (e) {
			
			openLoading()
			// let getNik = e.value
			
			Get("penduduk/find", e.value, data => {
				if(data.results){
					const alamat = generateAlamat(data.results);
					let alamat_kk = "";

					if(data.results.data_kk){
						alamat_kk = data.results.data_kk.alamat
					}

					if (jns === "pelapor") {
						// const tmpDetailPenduduk = formData.tmplistPenduduk[getNik]
		
						if (kioskMode === false) {
							Get("penduduk/kk/"+data.results.id_kk, null, dtkk => {
								let frmNik3 = [];
								let tmplistPenduduk3 = {};
								dtkk.results.forEach(val => {
									frmNik3.push({ value: val.id, label: val.id + ' (' + val.nama + ')' });
									tmplistPenduduk3 = {
										...tmplistPenduduk3,
										[val.id]: val
									}
								});
		
								let jenisKelamin = null;
								if (data.results.jk === 'Perempuan') {
									jenisKelamin = 'P';
								} else {
									jenisKelamin = 'L';
								}
		
								setFormData({
									...formData,
									nikStat: e,
									frmNik3,
									tmplistPenduduk3,
									status: {
										...formData.status,
										dataPenduduk: "block",
										jenis_kelamin_pelapor: jenisKelamin,
									},
								})
								setDt({
									...dt,
									nik: e.value,
									nik_pelapor: e.value,
									kk: data.results.id_kk,
									nama: data.results.nama,
									nama_pemohon: data.results.nama,
									tempat_lahir: data.results.tempat_lahir,
									tanggal_lahir: new Date(data.results.tanggal_lahir),
									pekerjaan: data.results.data_pekerjaan.nama,
									pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
									agama: data.results.data_agama.nama,
									jenis_kelamin: data.results.jk,
									alamat: alamat,
									alamat_kk: alamat_kk,
									kewarganegaraan: "Indonesia",
									status_perkawinan: {
										value: data.results.status_perkawinan,
										label: data.results.status_perkawinan
									},
									detail: [],
									status_perkawinan_lk: null,
									status_perkawinan_pr: null,
									status_perkawinan_lk_lainnya: "",
								})

								closeLoading()
							})
						} else { // Jika mode kiosk langsung set tanpa get list kk keluarga krna sudah ada
							setFormData({
								...formData,
								nikStat: e,
								status: {
									...formData.status,
									dataPenduduk: "block",
								},
							})
							setDt({
								...dt,
								nik: data.results.id,
								nik_pelapor: data.results.id,
								kk: data.results.id_kk,
								nama_pemohon: data.results.nama,
								tempat_lahir: data.results.tempat_lahir,
								tanggal_lahir: new Date(
									data.results.tanggal_lahir
								),
								pekerjaan: data.results.data_pekerjaan.nama,
								pendidikan_terakhir: data.results.data_pendidikan_terakhir.nama,
								agama: data.results.data_agama.nama,
								jenis_kelamin: data.results.jk,
								alamat: alamat,
								alamat_kk: alamat_kk,
								kewarganegaraan: 'Indonesia',
								status_perkawinan: {
									value: data.results.status_perkawinan,
									label: data.results.status_perkawinan
								},
								detail: [],
								status_perkawinan_lk: null,
								status_perkawinan_pr: null,
								status_perkawinan_lk_lainnya: "",
							})

							closeLoading()
						}

					} else if (jns === "pengikut") {
						// const tmpDetailPenduduk3 = formData.tmplistPenduduk3[getNik]
		
						let detail = dt.detail
						detail.push({
							nik: data.results.id,
							nama: data.results.nama,
							jenis_kelamin: data.results.jk,
							tanggal_lahir: new Date(
								data.results.tanggal_lahir
							),
							tempat_lahir: data.results.tempat_lahir,
							pekerjaan: data.results.data_pekerjaan.nama,
							pendidikan: data.results.data_pendidikan_terakhir.nama,
							alamat: alamat,
							alamat_kk: alamat_kk,
							shdk: data.results.data_shdk.nama,
							keterangan: "",
						})
		
						setDt({
							...dt,
							detail
						})

						closeLoading()
					}
				}
				else{
					closeLoading()
					const alertData = {
						show: true,
						basicType: "warning",
						basicTitle: "Data Penduduk",
						pesanAlert: "Data tidak lengkap"
					}
					setAlert(alertData)
				}
			})

		} else {
			openLoading()

			switch (jns) {
				case "pelapor":
					Get("penduduk", null, data => {
						let frmNik = [];
						data.results.data.forEach(dt => {
						  frmNik.push({ value: dt.id, label: dt.id + ' (' + dt.nama + ')' });
						});

						setDt({
							...dt,
							nama_pemohon: '',
							tempat_lahir: '',
							tanggal_lahir: null,
							pekerjaan: '',
							pendidikan_terakhir: '',
							agama: '',
							status_perkawinan: '',
							jenis_kelamin: '',
							alamat: '',
							alamat_kk: '',
							status_perkawinan: null,
							status_perkawinan_lk: null,
							status_perkawinan_pr: null,
							status_perkawinan_lk_lainnya: "",
							detail: []
						})
						setFormData({
							...formData,
							status: {
								...formData.status,
								dataPenduduk: "none",
								nikMantan: "none",
        						jenis_kelamin_pelapor: null,
							},
							nikStat: null,
							frmNik: frmNik,
						})

						closeLoading()
					})
					break;
				case "pengikut":
					setFormData({
						...formData,
						nik3Stat: null
					})
					closeLoading()
					break;
				default:
					break;
			}
		}
	};

	const gantiTgl = (date, fld) => {
		switch (fld) {
		  	case "tanggal_lahir_ayah":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						tanggal_lahir_ayah: new Date(tgl)
					})
				}
			break;
			case "tanggal_lahir_ibu":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						tanggal_lahir_ibu: new Date(tgl)
					})
				}
			break;
			case "tanggal_lahir_pasangan":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						tanggal_lahir_pasangan: new Date(tgl)
					})
				}
			break;
			case "tanggal_lahir_ex_pasangan":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						tanggal_lahir_ex_pasangan: new Date(tgl)
					})
				}
			break;
			case "tanggal_pernikahan":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						tanggal_pernikahan: new Date(tgl)
					})
				}
			break;
			case "tanggal_pernikahan":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD');
					setDt({
						...dt,
						tanggal_pernikahan: new Date(tgl)
					})
				}
			break;
			case "jam_pernikahan":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD HH:mm');
					setDt({
						...dt,
						jam_pernikahan: new Date(tgl),
					})
				}
			break;
			case "tanggal_ex_meninggal":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD HH:mm');
					setDt({
						...dt,
						tanggal_ex_meninggal: new Date(tgl),
					})
				}
			break;
			case "waktu_pernikahan":
				if (typeof date._isValid !== 'undefined') {
					let tgl = date.format('YYYY-MM-DD HH:mm:ss');
					let ex_tgl = tgl.split(" ");
					let tgl_nikah = ex_tgl[0]
					let jam_nikah = ex_tgl[1]
			
					setDt({
						...dt,
						tanggal_pernikahan: tgl_nikah,
						jam_pernikahan: jam_nikah,
						waktu_pernikahan: new Date(tgl)
					})
				}
			break;

			

		  	default:
			// no default
			break;
		}
	};

	const tambahLampiran = e => {
		let lampiran = dt.lampiran;
		lampiran.push("");
	
		setDt({
		  	...dt,
			lampiran: lampiran
		});
	};
	const hapusLampiran = i => {
		// console.log(i);
		let lampiran = dt.lampiran;
		lampiran.splice(i, 1);
		setDt({
			...dt,
			lampiran: lampiran
		});
	};

	const simpan = (e) => {
		e.preventDefault();

		openLoading()

		let validasiPemohon = false;
		let validasiAyah = true;
		let validasiIbu = true;
		let validasiPasangan = false;
		let validasiPernikahan = false;
		let validasiExPasangan = false;

		let dataEx = {};

		if (formData.nikStat !== null && dt.status_perkawinan && formData.status.jenis_kelamin_pelapor !== null) {
			if(formData.status.jenis_kelamin_pelapor === "L" && dt.status_perkawinan_lk){
				validasiPemohon = true
			}
			else if(formData.status.jenis_kelamin_pelapor === "P" && dt.status_perkawinan_pr){
				validasiPemohon = true
			}

			if(dt.status_perkawinan.label === "Cerai mati"){
				if(
					dt.tanggal_lahir_ex_pasangan &&
					dt.tanggal_ex_meninggal
				){
					validasiExPasangan = true;
					dataEx = {
						tanggal_lahir_ex_pasangan: dateFormat(new Date(dt.tanggal_lahir_ex_pasangan), 'yyyy-mm-dd'),
						pekerjaan_ex_pasangan: dt.pekerjaan_ex_pasangan,
						nik_ex_pasangan: dt.nik_ex_pasangan,
						nama_ex_pasangan: dt.nama_ex_pasangan,
						tempat_lahir_ex_pasangan: dt.tempat_lahir_ex_pasangan,
						jenis_kelamin_ex_pasangan: dt.jenis_kelamin_ex_pasangan,
						agama_ex_pasangan: dt.agama_ex_pasangan,
						alamat_ex_pasangan: dt.alamat_ex_pasangan,
						kewarganegaraan_ex_pasangan: "Indonesia",
						bin_binti_ex_pasangan: dt.bin_binti_ex_pasangan,
						tanggal_ex_meninggal: dateFormat(new Date(dt.tanggal_ex_meninggal), 'yyyy-mm-dd'),
						tempat_ex_meninggal: dt.tempat_ex_meninggal,
						status_hubungan: dt.status_hubungan,
					};
				}
			}
			else{
				validasiExPasangan = true;
			}
		}

		if (dt.tanggal_lahir_ayah) {
			validasiAyah = true;
		}

		if (dt.tanggal_lahir_ibu) {
			validasiIbu = true;
		}

		if (dt.tanggal_lahir_pasangan) {
			validasiPasangan = true;
		}

		if (dt.waktu_pernikahan) {
			validasiPernikahan = true;
		}

		if (
			validasiPemohon &&
			validasiAyah &&
			validasiIbu &&
			validasiPasangan &&
			validasiPernikahan &&
			validasiExPasangan
		) {
			let data_ayah={
				nik_ayah: dt.nik_ayah,
				nama_ayah_pemohon: dt.nama_ayah,
				bin_binti_ayah: dt.bin_binti_ayah,
				tempat_lahir_ayah: dt.tempat_lahir_ayah,
				tanggal_lahir_ayah: dt.tanggal_lahir_ayah?dateFormat(new Date(dt.tanggal_lahir_ayah), 'yyyy-mm-dd'):'',
				kewarganegaraan_ayah: "Indonesia",
				agama_ayah: dt.agama_ayah,
				pekerjaan_ayah: dt.pekerjaan_ayah,
				alamat_ayah: dt.alamat_ayah,
			}
	
			let data_ibu = {
				nik_ibu: dt.nik_ibu,
				nama_ibu_pemohon: dt.nama_ibu,
				bin_binti_ibu: dt.bin_binti_ibu,
				tempat_lahir_ibu: dt.tempat_lahir_ibu,
				tanggal_lahir_ibu: dt.tanggal_lahir_ibu?dateFormat(new Date(dt.tanggal_lahir_ibu), 'yyyy-mm-dd'):'',
				kewarganegaraan_ibu: "Indonesia",
				agama_ibu: dt.agama_ibu,
				pekerjaan_ibu: dt.pekerjaan_ibu,
				alamat_ibu: dt.alamat_ibu,
			}
	
			let data_pasangan = {
				nik_pasangan: dt.nik_pasangan,
				nama_pasangan: dt.nama_pasangan,
				bin_binti_pasangan: dt.bin_binti_pasangan,
				tempat_lahir_pasangan: dt.tempat_lahir_pasangan,
				tanggal_lahir_pasangan: dateFormat(new Date(dt.tanggal_lahir_pasangan), 'yyyy-mm-dd'),
				kewarganegaraan_pasangan: "Indonesia",
				agama_pasangan: dt.agama_pasangan,
				pekerjaan_pasangan: dt.pekerjaan_pasangan,
				alamat_pasangan: dt.alamat_pasangan,
			}
	
			let data_pernikahan = {
				tanggal_pernikahan: dateFormat(new Date(dt.waktu_pernikahan), 'yyyy-mm-dd'),
				jam_pernikahan: dateFormat(dt.waktu_pernikahan, 'yyyy-mm-dd HH:MM'),
				waktu_pernikahan: dateFormat(dt.waktu_pernikahan, 'yyyy-mm-dd HH:MM'),
				lokasi_pernikahan: dt.lokasi_pernikahan,
				lampiran: dt.lampiran,
			}
			let detail_surat = {
				status_perkawinan_lk: dt.status_perkawinan_lk?dt.status_perkawinan_lk:null,
                status_perkawinan_pr: dt.status_perkawinan_pr?dt.status_perkawinan_pr:null,
                status_perkawinan_lk_lainnya: dt.status_perkawinan_lk_lainnya,
				data_ayah:data_ayah,
				data_ibu:data_ibu,
				data_pasangan:data_pasangan,
				data_ex_pasangan:dataEx,
				data_pernikahan:data_pernikahan,
			}
	
			let bodyRaw = {
				...dt,
				tujuan_pembuatan: '-',
				status_perkawinan: dt.status_perkawinan.label
					? dt.status_perkawinan.label
					: dt.status_perkawinan,
				detail_surat: JSON.stringify(detail_surat),
			}

			if (dt.uuid === '') {
				if (kioskMode) {
					bodyRaw.id_jenis = props.id_jenis
				} else {
					bodyRaw.id_jenis = props.location.state.uuid
				}
			}

			bodyRaw['tanggal_lahir'] = dateFormat(new Date(dt.tanggal_lahir), 'yyyy-mm-dd');

			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}

			Post(
				"surat-keterangan/grup/" + metode,
				bodyRaw.uuid,
				bodyRaw,
				res => {

					// For testing
					if (props.resSubmit) {
						props.resSubmit(res.status)
					}

					// this.tutupForm();
					setFormData({
						...formData,
						status: {
							...formData.status,
							btnForm: false,
							form: false,
						}
					})
					setIsOpen(false)

					if (kioskMode) {
						if (res.status === resstat) {
							let dataAntrian = {
								nama: props.data.results.nama,
								nik: props.data.results.id,
								keterangan: '',
								uuid_surat:res.data.results.uuid_surat,
								kode_surat:res.data.results.kode_surat,
							};

							// Set Data Surat
							props.getDataSurat(res.data.results);

							setTimeout(function () {
								Get('persetujuan/kiosk/' + dataAntrian.uuid_surat + '/' + props.id_jenis, null,  (res2) => {

									closeLoading()

									if (res2.code === 201) {
										props.getAntrian('Blangko Nikah', 'berhasil', false, dataAntrian);
									}
									else{
										props.getAntrian('Blangko Nikah', 'gagal');
									}
								});
							}.bind(this),1000)
						} else {
							closeLoading()
							props.getAntrian('Blangko Nikah', 'gagal');
						}

					} else {

						if (res.status === resstat) {
							const alertData = {
								get_data_surat:{
									uuid_surat:res.data.results.uuid_surat,
									kode_surat:res.data.results.kode_surat,
								},
								status:{
									frmPreviewDraft: true,
									jenis_form: psn,
								}
								// show: true,
								// basicType: "success",
								// basicTitle: "Data Surat Keterangan Penghasilan",
								// pesanAlert: "Berhasil " + psn + " Data",
								// successAlert: true,
							}
							closeLoading()
							setAlert(alertData)
						} else {
							const alertData = {
								show: true,
								basicType: "danger",
								basicTitle: "Data Blangko Nikah",
								pesanAlert: "Gagal " + psn + " Data"
							}
							closeLoading()
							setAlert(alertData)
						}

						// Refresh list
						setStatusRefresh(true)
					}

				}
			);
		} else {
			if (kioskMode){
				props.getAntrian('Blangko Nikah', 'gagal', true);
				closeLoading()
			}
			else{
				const alertData = {
					show: true,
					basicType: "info",
					basicTitle: "Data Belum Lengkap",
					pesanAlert: "Mohon isi seluruh data dengan benar"
				}
				closeLoading()
				setAlert(alertData)
			}
    	}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Blangko Nikah</h5>
				</div>
				<div className="modal-body">
					<p>
						Data identitas akan terisi secara otomatis saat NIK dipilih.
						Jika ada ketidak sesuaian data, silakan ubah di data master
						penduduk.
					</p>
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>

					{/* Data Pelapor */}
					<FormGroup className="row">
						<Col sm="12">
							<Label className="col-form-label" htmlFor="nik">
								<b>NIK Pemohon</b>
							</Label>
							<div data-testid="selectNIK">
								<Select
									inputId="nik"
									classNamePrefix="select"
									onChange={e => {
										getPenduduk(e, "nik", "pelapor");
									}}
									defaultValue={formData.nikStat}
									value={formData.nikStat}
									name="NIK"
									options={formData.frmNik}
									placeholder="Pilih NIK Pemohon"
									onInputChange={e => handleInputChangeNIK(e, "nik")}
									isClearable
								/>
							</div>
						</Col>
					</FormGroup>
					<div style={{ display: formData.status.dataPenduduk }}>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Nama Pemohon</b>
								</Label>
								<input
									className="form-control"
									id="nama"
									type="text"
									placeholder="Nama Pemohon"
									value={dt.nama_pemohon}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tempat Lahir</b>
								</Label>
								<input
									className="form-control"
									id="tempat_lahir"
									type="text"
									placeholder="Tempat Lahir"
									value={dt.tempat_lahir}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tanggal Lahir</b>
								</Label>
								<input
									className="form-control"
									id="tanggal_lahir"
									type="text"
									placeholder="Tanggal Lahir"
									value={new Date(dt.tanggal_lahir).toLocaleDateString("id-ID")}
									readOnly
									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Alamat</b>
								</Label>
								<input
									className="form-control"
									id="alamat_kk"
									type="text"
									placeholder="Alamat"
									value={dt.alamat_kk}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Wilayah</b>
								</Label>
								<input
									className="form-control"
									id="alamat"
									type="text"
									placeholder=""
									value={dt.alamat}
									readOnly

									style={{ backgroundColor: "#c9d1d8" }}
									disabled
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									&nbsp;
								</Label>
								<small><font color="red">* Jika data wilayah kosong, silahkan perbaiki data alamat kartu keluarga dan pastikan data lengkap terlebih dahulu</font></small>
							</Col>
						</FormGroup>
						<FormGroup className="row">
							<Col sm="12">
								<Label className="col-form-label" htmlFor="inputEmail3">
									<b>Status Perkawinan</b>
								</Label>
								<Select
									nputId="status_perkawinan"
									classNamePrefix="select"
									onChange={e => {
										changeSelectValue(
											e,
											"status_perkawinan",
											"status_perkawinan"
										);
									}}
									value={dt.status_perkawinan}
									name="status_perkawinan"
									options={formData.frmStatusPerkawinan}
									placeholder="Pilih Status Perkawinan"
									isClearable
								/>
							</Col>
						</FormGroup>
					</div>
					<div style={{ display: formData.status.jenis_kelamin_pelapor === "L"?"block":"none"}}>
						<FormGroup className="row">
							<Col sm="12">
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status Perkawinan Detail</b>
							</Label>
							<Select
								nputId="status_perkawinan_lk"
								classNamePrefix="select"
								onChange={e => {
									handleSelectChange(
										e,
										"status_perkawinan_lk"
									);
								}}
								value={dt.status_perkawinan_lk}
								name="status_perkawinan_lk"
								options={formData.frmStatusPerkawinanLk}
								placeholder="Pilih Status Perkawinan"
								isClearable
							/>
							</Col>
						</FormGroup>
					</div>
					<div id="input-status" style={{ display: dt.status_perkawinan_lk && dt.status_perkawinan_lk.label === "Lainnya" ? "block" : "none" }}>
						<FormGroup className="row">
							<Col sm="12">
								<Label
								className="col-form-label"
								htmlFor="status_perkawinan_lk"
								>
								<b>Beristri Ke</b>
								</Label>
								<input
									className="form-control"
									placeholder="Contoh : 2"
									value={dt.status_perkawinan_lk_lainnya}
									type="text"
									id="status_perkawinan_lk"
									name="status_perkawinan_lk"
									onChange={e => handleInputChange(e,"status_perkawinan_lk_lainnya")}
									required={dt.status_perkawinan_lk && dt.status_perkawinan_lk.label === "Lainnya"?true:false}
								/>
							</Col>
						</FormGroup>
					</div>
					<div style={{ display: formData.status.jenis_kelamin_pelapor === "P"?"block":"none"}}>
						<FormGroup className="row">
							<Col sm="12">
							<Label className="col-form-label" htmlFor="inputEmail3">
								<b>Status Perkawinan Detail</b>
							</Label>
							<Select
								nputId="status_perkawinan_pr"
								classNamePrefix="select"
								onChange={e => {
									handleSelectChange(
										e,
										"status_perkawinan_pr"
									);
								}}
								value={dt.status_perkawinan_pr}
								name="status_perkawinan_pr"
								options={formData.frmStatusPerkawinanPr}
								placeholder="Pilih Status Perkawinan"
								isClearable
							/>
							</Col>
						</FormGroup>
					</div>
					{/* Data Pelapor */}

					{/* Data Ayah */}
					<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
						<b>Data Ayah</b>
					</div>
					<FormGroup className="row">
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Nik Ayah</b>
							</Label>
							<input
								data-testid="nik_ayah"
								name="nik_ayah"
								className="form-control"
								id="nik_ayah"
								type="text"
								placeholder="Masukkan Nik Ayah"
								defaultValue={dt.nik_ayah}
								onChange={e => handleInputChange(e, "nik_ayah")}
								pattern="\d{1,16}"
								minLength={16}
								maxLength={16}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Nama Ayah</b>
							</Label>
							<input
								data-testid="nama_ayah"
								name="nama_ayah"
								className="form-control"
								id="nama_ayah"
								type="text"
								placeholder="Masukkan Nama Ayah"
								defaultValue={dt.nama_ayah}
								onChange={e => handleInputChange(e,"nama_ayah")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Bin Ayah</b>
							</Label>
							<input
								data-testid="bin_binti_ayah"
								name="bin_binti_ayah"
								className="form-control"
								id="bin_binti_ayah"
								type="text"
								placeholder="Masukkan Bin Ayah"
								defaultValue={dt.bin_binti_ayah}
								onChange={e => handleInputChange(e,"bin_binti_ayah")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tempat Lahir Ayah</b>
							</Label>
							<input
								data-testid="tempat_lahir_ayah"
								name="tempat_lahir_ayah"
								className="form-control"
								id="tempat_lahir_ayah"
								type="text"
								placeholder="Masukkan Tempat Lahir Ayah"
								defaultValue={dt.tempat_lahir_ayah}
								onChange={e => handleInputChange(e,"tempat_lahir_ayah")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tanggal Lahir Ayah</b>
							</Label>
							<Datetime
								inputProps={{ 
									"data-testid": "tanggal_lahir_ayah", 
									placeholder: 'Tanggal Lahir Ayah', 
									// required: true
								}}
								inputId="tanggal_lahir_ayah"
								name="tanggal_lahir_ayah"
								locale="id-ID"
								timeFormat={false}
								dateFormat="DD/MM/yyyy"
								input={true}
								closeOnTab={true}
								initialValue={(dt.tanggal_lahir_ayah)}
								value={(dt.tanggal_lahir_ayah)}
								onChange={e => {
									gantiTgl(e, 'tanggal_lahir_ayah')
								}}
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Agama Ayah</b>
							</Label>
							<input
								data-testid="agama ayah"
								name="agama_ayah"
								className="form-control"
								id="agama_ayah"
								type="text"
								placeholder="Masukkan Agama Ayah"
								defaultValue={dt.agama_ayah}
								onChange={e => handleInputChange(e,"agama_ayah")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Pekerjaan Ayah</b>
							</Label>
							<input
								data-testid="pekerjaan ayah"
								name="pekerjaan_ayah"
								className="form-control"
								id="pekerjaan_ayah"
								type="text"
								placeholder="Masukkan Pekerjaan Ayah"
								defaultValue={dt.pekerjaan_ayah}
								onChange={e => handleInputChange(e,"pekerjaan_ayah")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Alamat Ayah</b>
							</Label>
							<input
								data-testid="alamat ayah"
								name="alamat_ayah"
								className="form-control"
								id="alamat_ayah"
								type="text"
								placeholder="Masukkan Alamat Ayah"
								defaultValue={dt.alamat_ayah}
								onChange={e => handleInputChange(e, "alamat_ayah")}
								// required
							/>
						</Col>
					</FormGroup>
					{/* Data Ayah */}

					{/* Data Ibu */}
					<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
						<b>Data Ibu</b>
					</div>
					<FormGroup className="row">
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Nik Ibu</b>
							</Label>
							<input
								data-testid="nik ibu"
								name="nik_ibu"
								className="form-control"
								id="nik_ibu"
								type="text"
								placeholder="Masukkan Nik Ibu"
								defaultValue={dt.nik_ibu}
								onChange={e => handleInputChange(e,"nik_ibu")}
								pattern="\d{1,16}"
								minLength={16}
								maxLength={16}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Nama Ibu</b>
							</Label>
							<input
								data-testid="nama ibu"
								name="nama_ibu"
								className="form-control"
								id="nama_ibu"
								type="text"
								placeholder="Masukkan Nama Ibu"
								defaultValue={dt.nama_ibu}
								onChange={e => handleInputChange(e,"nama_ibu")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Binti Ibu</b>
							</Label>
							<input
								data-testid="bin_binti_ibu"
								name="bin_binti_ibu"
								className="form-control"
								id="bin_binti_ibu"
								type="text"
								placeholder="Masukkan Binti Ibu"
								defaultValue={dt.bin_binti_ibu}
								onChange={e => handleInputChange(e,"bin_binti_ibu")}

								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tempat Lahir Ibu</b>
							</Label>
							<input
								data-testid="tempat lahir ibu"
								name="tempat_lahir_ibu"
								className="form-control"
								id="tempat_lahir_ibu"
								type="text"
								placeholder="Masukkan Tempat Lahir Ibu"
								defaultValue={dt.tempat_lahir_ibu}
								onChange={e => handleInputChange(e,"tempat_lahir_ibu")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tanggal Lahir Ibu</b>
							</Label>
							<Datetime
								inputProps={{ 
									"data-testid": "tanggal_lahir_ibu", 
									placeholder: 'Tanggal Lahir Ibu', 
									// required: true
								}}
								inputId="tanggal_lahir_ibu"
								name="tanggal_lahir_ibu"
								locale="id-ID"
								timeFormat={false}
								dateFormat="DD/MM/yyyy"
								input={true}
								closeOnTab={true}
								initialValue={(dt.tanggal_lahir_ibu)}
								value={(dt.tanggal_lahir_ibu)}
								onChange={e => {
									gantiTgl(e,'tanggal_lahir_ibu')
								}}
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Agama Ibu</b>
							</Label>
							<input
								data-testid="agama ibu"
								name="agama_ibu"
								className="form-control"
								id="agama_ibu"
								type="text"
								placeholder="Masukkan Agama Ibu"
								defaultValue={dt.agama_ibu}
								onChange={e => handleInputChange(e,"agama_ibu")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Pekerjaan Ibu</b>
							</Label>
							<input
								data-testid="pekerjaan ibu"
								name="pekerjaan_ibu"
								className="form-control"
								id="pekerjaan_ibu"
								type="text"
								placeholder="Masukkan Pekerjaan Ibu"
								defaultValue={dt.pekerjaan_ibu}
								onChange={e => handleInputChange(e, "pekerjaan_ibu")}
								// required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Alamat Ibu</b>
							</Label>
							<input
								data-testid="alamat ibu"
								name="alamat_ibu"
								className="form-control"
								id="alamat_ibu"
								type="text"
								placeholder="Masukkan Alamat Ibu"
								defaultValue={dt.alamat_ibu}
								onChange={e => handleInputChange(e, "alamat_ibu")}
								// required
							/>
						</Col>
					</FormGroup>
					{/* Data Ibu */}

					{/* Data Pasangan */}
					<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
						<b>Data Pasangan</b>
					</div>
					<FormGroup className="row">
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Nik Pasangan</b>
							</Label>
							<input
								data-testid="nik pasangan"
								name="nik_pasangan"
								className="form-control"
								id="nik_pasangan"
								type="text"
								placeholder="Masukkan Nik Pasangan"
								defaultValue={dt.nik_pasangan}
								onChange={e => handleInputChange(e,"nik_pasangan")}
								required
								pattern="\d{1,16}"
								minLength={16}
								maxLength={16}
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Nama Pasangan</b>
							</Label>
							<input
								data-testid="nama pasangan"
								name="nama_pasangan"
								className="form-control"
								id="nama_pasangan"
								type="text"
								placeholder="Masukkan Nama pasangan"
								defaultValue={dt.nama_pasangan}
								onChange={e => handleInputChange(e,"nama_pasangan")}
								required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Bin/Binti Pasangan</b>
							</Label>
							<input
								data-testid="bin_binti_pasangan"
								name="bin_binti_pasangan"
								className="form-control"
								id="bin_binti_pasangan"
								type="text"
								placeholder="Masukkan Bin/Binti Pasangan"
								defaultValue={dt.bin_binti_pasangan}
								onChange={e => handleInputChange(e, "bin_binti_pasangan")}
								required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tempat Lahir Pasangan</b>
							</Label>
							<input
								data-testid="tempat lahir pasangan"
								name="tempat_lahir_pasangan"
								className="form-control"
								id="tempat_lahir_pasangan"
								type="text"
								placeholder="Masukkan Tempat Lahir Pasangan"
								defaultValue={dt.tempat_lahir_pasangan}
								onChange={e => handleInputChange(e,"tempat_lahir_pasangan")}
								required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Tanggal Lahir Pasangan</b>
							</Label>
							<Datetime
								inputProps={{ 
									"data-testid": "tanggal_lahir_pasangan", 
									placeholder: 'Tanggal Lahir pasangan', 
									required: true
								}}
								inputId="tanggal_lahir_pasangan"
								name="tanggal_lahir_pasangan"
								locale="id-ID"
								timeFormat={false}
								dateFormat="DD/MM/yyyy"
								input={true}
								closeOnTab={true}
								initialValue={(dt.tanggal_lahir_pasangan)}
								value={(dt.tanggal_lahir_pasangan)}
								onChange={e => {
									gantiTgl(e, 'tanggal_lahir_pasangan')
								}}
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Agama Pasangan</b>
							</Label>
							<input
								data-testid="agama pasangan"
								name="agama_pasangan"
								className="form-control"
								id="agama_pasangan"
								type="text"
								placeholder="Masukkan Agama Pasangan"
								defaultValue={dt.agama_pasangan}
								onChange={e => handleInputChange(e, "agama_pasangan")}
								required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Pekerjaan Pasangan</b>
							</Label>
							<input
								data-testid="pekerjaan pasangan"
								name="pekerjaan_pasangan"
								className="form-control"
								id="pekerjaan_pasangan"
								type="text"
								placeholder="Masukkan Pekerjaan Pasangan"
								defaultValue={dt.pekerjaan_pasangan}
								onChange={e => handleInputChange(e, "pekerjaan_pasangan")}
								required
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Alamat Pasangan</b>
							</Label>
							<input
								data-testid="alamat pasangan"
								name="alamat_pasangan"
								className="form-control"
								id="alamat_pasangan"
								type="text"
								placeholder="Masukkan Alamat Pasangan"
								defaultValue={dt.alamat_pasangan}
								onChange={e => handleInputChange(e, "alamat_pasangan")}
								required
							/>
						</Col>
					</FormGroup>
					{/* Data Pasangan */}

					{/* Data Pasangan Sebelumnya */}
					<div id="input-mantan" style={{ display: formData.status.nikMantan }}>
						<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
							<b>Data Pasangan Sebelumnya</b>
						</div>
						<FormGroup className="row">
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Nik Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="nik pasangan"
									name="nik_ex_pasangan"
									className="form-control"
									id="nik_ex_pasangan"
									type="text"
									placeholder="Masukkan Nik Pasangan Sebelumnya"
									defaultValue={dt.nik_ex_pasangan}
									onChange={e => handleInputChange(e, "nik_ex_pasangan")}
									pattern="\d{1,16}"
									minLength={16}
									maxLength={16}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Nama Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="nama pasangan"
									name="nama_ex_pasangan"
									className="form-control"
									id="nama_ex_pasangan"
									type="text"
									placeholder="Masukkan Nama pasangan Sebelumnya"
									defaultValue={dt.nama_ex_pasangan}
									onChange={e => handleInputChange(e,"nama_ex_pasangan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Bin/Binti Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="bin_binti_ex_pasangan"
									name="bin_binti_ex_pasangan"
									className="form-control"
									id="bin_binti_ex_pasangan"
									type="text"
									placeholder="Masukkan Bin/Binti Pasangan Sebelumya"
									defaultValue={dt.bin_binti_ex_pasangan}
									onChange={e => handleInputChange(e,"bin_binti_ex_pasangan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tempat Lahir Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="tempat lahir pasangan"
									name="tempat_lahir_ex_pasangan"
									className="form-control"
									id="tempat_lahir_ex_pasangan"
									type="text"
									placeholder="Masukkan Tempat Lahir Pasangan Sebelumnya"
									defaultValue={dt.tempat_lahir_ex_pasangan}
									onChange={e => handleInputChange(e, "tempat_lahir_ex_pasangan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tanggal Lahir Pasangan Sebelumnya</b>
								</Label>
								<Datetime
									inputProps={{ 
										"data-testid": "tanggal_lahir_ex_pasangan", 
										placeholder: 'Tanggal Lahir Pasangan Sebelumnya', 
										// required: true
									}}
									inputId="tanggal_lahir_ex_pasangan"
									name="tanggal_lahir_ex_pasangan"
									locale="id-ID"
									timeFormat={false}
									dateFormat="DD/MM/yyyy"
									input={true}
									closeOnTab={true}
									initialValue={(dt.tanggal_lahir_ex_pasangan)}
									value={(dt.tanggal_lahir_ex_pasangan)}
									onChange={e => {
										gantiTgl(e, 'tanggal_lahir_ex_pasangan')
									}}
									required={
										formData.status.nikMantan !== "none" ? true : false
									}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Agama Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="agama ex pasangan"
									name="agama_ex_pasangan"
									className="form-control"
									id="agama_ex_pasangan"
									type="text"
									placeholder="Masukkan Agama Pasangan Sebelumnya"
									defaultValue={dt.agama_ex_pasangan}
									onChange={e => handleInputChange(e, "agama_ex_pasangan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Pekerjaan Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="pekerjaan ex pasangan"
									name="pekerjaan_ex_pasangan"
									className="form-control"
									id="pekerjaan_ex_pasangan"
									type="text"
									placeholder="Masukkan Pekerjaan Pasangan Sebelumnya"
									defaultValue={dt.pekerjaan_ex_pasangan}
									onChange={e => handleInputChange(e,"pekerjaan_ex_pasangan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Alamat Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="alamat ex pasangan"
									name="alamat_ex_pasangan"
									className="form-control"
									id="alamat_ex_pasangan"
									type="text"
									placeholder="Masukkan Alamat Pasangan Sebelumnya"
									defaultValue={dt.alamat_ex_pasangan}
									onChange={e => handleInputChange(e, "alamat_ex_pasangan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tempat Meninggal Pasangan Sebelumnya</b>
								</Label>
								<input
									data-testid="tempat ex meninggal"
									name="tempat_ex_meninggal"
									className="form-control"
									id="tempat_ex_meninggal"
									type="text"
									placeholder="Masukkan Tempat Meninggal Pasangan Sebelumnya"
									defaultValue={dt.tempat_ex_meninggal}
									onChange={e => handleInputChange(e,"tempat_ex_meninggal")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Tanggal Meninggal Pasangan Sebelumnya</b>
								</Label>
								<Datetime
									inputProps={{ 
										"data-testid": "tanggal_ex_meninggal", 
										placeholder: 'Tanggal Meninggal Pasangan Sebelumnya', 
										// required: true
									}}
									inputId="tanggal_ex_meninggal"
									name="tanggal_ex_meninggal"
									locale="id-ID"
									timeFormat={false}
									dateFormat="DD/MM/yyyy"
									input={true}
									closeOnTab={true}
									initialValue={(dt.tanggal_ex_meninggal)}
									value={(dt.tanggal_ex_meninggal)}
									onChange={e => {
										gantiTgl(e,'tanggal_ex_meninggal')
									}}
									required={
										formData.status.nikMantan !== "none" ? true : false
									}
								/>
							</Col>
							<Col sm="12">
								<Label
									className="col-form-label"
									htmlFor="inputEmail3"
								>
									<b>Status Hubungan</b>
								</Label>
								<input
									data-testid="status hubungan"
									name="status_hubungan"
									className="form-control"
									id="status_hubungan"
									type="text"
									placeholder="Contoh : Istri"
									defaultValue={dt.status_hubungan}
									onChange={e => handleInputChange(e,"status_hubungan")}
									required={dt.status_perkawinan && dt.status_perkawinan.label === "Cerai mati"?true:false}
								/>
							</Col>
						</FormGroup>
					</div>
					{/* Data Pasangan Sebelumnya */}

					{/* Data Pernikahan */}
					<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
						<b>Data Pernikahan</b>
					</div>
					<FormGroup className="row">
						<Col sm="12">
						<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Waktu Pernikahan</b>
						</Label>
							<Datetime
								inputProps={{ "data-testid": "waktu_pernikahan", placeholder: 'Waktu Pernikahan', required: true }}
								inputId="waktu_pernikahan"
								name="waktu_pernikahan"
								locale="id-ID"
								timeFormat={"HH:mm"}
								dateFormat="DD/MM/yyyy"
								input={false}
								closeOnSelect={false}
								initialValue={dt.waktu_pernikahan}
								value={dt.waktu_pernikahan}
								onChange={e => {
									gantiTgl(e,'waktu_pernikahan')
								}}
							/>
						</Col>
						<Col sm="12">
							<Label
								className="col-form-label"
								htmlFor="inputEmail3"
							>
								<b>Lokasi Pernikahan</b>
							</Label>
							<input
								data-testid="lokasi pernikahan"
								name="lokasi_pernikahan"
								className="form-control"
								id="lokasi_pernikahan"
								type="text"
								placeholder="Contoh : Gedung Serbaguna"
								defaultValue={dt.lokasi_pernikahan}
								onChange={e => handleInputChange(e,"lokasi_pernikahan")}
								required
							/>
						</Col>
						<br />

						{/* Data Lampiran */}
						<Col sm="12">
							<br /><br />
							<div style={{backgroundColor:'grey',paddingTop:'15px',paddingBottom:'15px',paddingLeft:'15px',color:'white',marginBottom:'15px'}}>
								<b>Lampiran</b>
							</div>
						</Col>
						<Col sm="12">
							<Button
								className="btn btn-success"
								type="button"
								onClick={tambahLampiran}
							>
								Tambah Lampiran
							</Button>
							<small className="form-text text-danger">
								* Jika ada tambahan lampiran yang akan diperiksa pada surat
								permohonan perkawinan
							</small>
							{dt.lampiran && dt.lampiran.map((data, i) => {
								let no = i + 1;
								return (
								<div className="input-group mt-3">
									<input
									key={i}
									id={"Lampiran" + no}
									data-testid="lampiran"
									name="lampiran"
									className="form-control mb-2"
									type="text"
									placeholder={"Lampiran " + no}
									defaultValue={data}
									value={data}
									onChange={e => {
										let currentLampiran = dt.lampiran;
										currentLampiran[i] = e.target.value;

										setDt({
											...dt,
											lampiran: currentLampiran,
										});
									}}
									/>
									{
									<button
										type="button"
										className="btn-sm btn ml-2 mb-2 btn-danger"
										onClick={() => hapusLampiran(i)}
										data-testid="btnHapusAcara"
									>
										Hapus
									</button>
									}
								</div>
								);
							})}
							<small className="form-text">
								Lampiran Sudah Meliputi:
								<ul className="row">
								<li className="col-lg-6 col-sm-12">
									- Surat pengantar perkawinan dari Desa/kelurahan
								</li>
								<li className="col-lg-6 col-sm-12">
									- Persetujuan calon mempelai
								</li>
								<li className="col-lg-6 col-sm-12">- Fotokopi KTP</li>
								<li className="col-lg-6 col-sm-12">- Fotokopi Akte Kelahiran</li>
								<li className="col-lg-6 col-sm-12">- Fotokopi Kartu Keluarga</li>
								<li className="col-lg-6 col-sm-12">
									- Pasphoto berlatar belakang biru ( 2x3 = 4 Lembar, 4x6 = 2
									Lembar)
								</li>
								</ul>
							</small>
						</Col>
						{/* Data Lampiran */}
					</FormGroup>
					{/* Data Pernikahan */}
				</div>
					<div className="modal-footer">
						<button
							type="button"
							className="btn btn-warning"
							onClick={() => {
								// Tutup modal
								setFormData({
									...formData,
									status: {
										...formData.status,
										form: false,
										frmPreviewDraft: false,
										jenis_form: '',
									}
								})
								setIsOpen(false)
							}}
						>
							Tutup
						</button>
						<button
							data-testid="btnSubmitCreate"
							type="submit"
							className="btn btn-primary-custom"
							disabled={formData.status.btnForm}
						>
							Simpan
						</button>
					</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalBlangkoNikah;
